mutation LeadAddSource($input: LeadAddSourceInput!) {
    leadAddSource(input: $input) {
        lead {
            id
        }
    }
}
